<main class="main" id="top">
  <div class="container" data-layout="container">
    <div class="row flex-center min-vh-100 py-6 text-center">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
        <img class="bg-auth-circle-shape" src="../../assets/img/illustrations/bg-shape.png" alt="" width="250">
        <img class="bg-auth-circle-shape-2" src="../../assets/img/illustrations/shape-1.png" alt="" width="150">
        <div class="card" *ngIf="!resetOpe">
          <div class="card-body p-4 p-sm-5">
            <h5 class="mb-0">Forgot your password?</h5><small>Enter your email and we'll send you a reset link.</small>
            <form class="mt-4" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <input class="form-control" type="email" placeholder="Email address" formControlName="email" tabindex="1" [ngClass]="{'is-invalid': submitted && forgotPasswordFormControl.email.errors }" />
                <div *ngIf="submitted && forgotPasswordFormControl.email.errors" class="invalid-feedback">
                  <div class="text-left" *ngIf="forgotPasswordFormControl.email.errors.required">Email is required</div>
                </div>
              </div>
              <div class="form-group">
                <button class="btn btn-primary btn-block mt-3" id="btnSend">Send reset link</button>
              </div>
            </form>
            <a [routerLink]="'/login'">Return to Login</a>
          </div>
        </div>
        <div *ngIf="forgotPasswordForm.errors?.invalidLogin" class="alert alert-danger mt-3 mb-0">
          Wrong e-mail address!
        </div>
        <div class="card" *ngIf="resetOpe">
          <div class="card-body p-4 p-sm-5">
            <div class="text-center">
              <img class="d-block mx-auto mb-4" src="../../assets/img/illustrations/envelope.png" alt="Email" width="70" />
              <h4>Please check your email!</h4>
              <p>
                An email has been sent to <strong>{{forgotPasswordFormControl.email.value}}</strong>. Please click on the included link to reset your password.
              </p><a class="btn btn-primary btn-sm mt-3" [routerLink]="'/login'"><span class="fas fa-chevron-left mr-1" data-fa-transform="shrink-4 down-1"></span>Return to login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
